import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import HomePage from "../pages/HomePage";
import CategoryPage from "../pages/CategoryPage";
import AddRecipePage from "../pages/AddRecipePage";

import AboutPage from "../pages/AboutPage";
import LoginPage from "../pages/LoginPage"; 
import { ProfilePage } from '../pages/ProfilePage';
import { SignUpPage } from '../pages/SignUpPage';
import { RecipeDetailPage } from "../pages/RecipeDetailPage";
import { EditProfilePage } from "../pages/EditProfilePage";
import { SubscriptionPage } from '../pages/SubscriptionPage';
import { OtpPage } from '../pages/OtpPage';
import PackTypeSelection from "../pages/PackTypeSelection";
import PackSelection from "../pages/PackSelection";
import ConfirmPage from "../pages/ConfirmPage";
import Auth from "../Auth/Auth";



const router = createBrowserRouter([
  
  {
    path: "/",
    element:  <HomePage />,
  },{
    path: "/category/:categoryId",
    element:  <CategoryPage />,  
  },{
    path: "/add-recipe",        
    element: <AddRecipePage />,
  },{
    path: "/profile",
    element:  <ProfilePage />,
  },{
    path: "/profile/edit",
    element: <EditProfilePage />,
  },{
    path: "/about",
    element: <AboutPage />,
  },{
    path: "/login",
    element: <LoginPage />,
  },{
    path:"/signup",
    element: <SignUpPage />,
  },{
    path: "/recipe/:recipeId",
    element:  <RecipeDetailPage />,
  },{
    path:"/subscribe",
    element:<SubscriptionPage />
  },{
    path:"/otp",
    element:<OtpPage />
  },
  {
    path:"/pack",
    element:<PackTypeSelection />
  },
  {
    path:"/pack/:offerType",
    element:<PackSelection />
  },
  {
    path:'/confirm',
    element:<ConfirmPage/>
  }
 
]);

const Routing = () => {
  return <RouterProvider router={router} />;
};

export default Routing;
